import { isVoidField } from '@formily/core'
import { connect, h, mapProps } from '@formily/vue'
import { defineComponent } from 'vue-demi'
import InnerItem from './item.vue'
/* eslint-disable vue/require-default-prop, vue/require-prop-types */
export const FormBaseItem = defineComponent({
  name: 'FormItemHorizontal',
  props: {
    className: {},
    name: {},
    required: {},
    label: {},
    addonAfter: {},
    asterisk: {},
    extra: {},
    feedbackText: {},
    feedbackStatus: {}, // 'error' | 'warning' | 'success' | 'pending'
    // 新增属性
    icon: {},
    arrow: {},
    marginBottom: {},
    noPadding: {},
  },
  setup(props, { slots, attrs }) {
    return () => {
      const {
        name,
        label,
        asterisk,
        extra,
        feedbackStatus,
        feedbackText,
        icon,
        arrow,
        marginBottom,
        noPadding,
      } = props

      return h(
        InnerItem,
        {
          props: {
            label,
            asterisk,
            extra,
            feedbackStatus,
            feedbackText,
            icon,
            arrow,
            marginBottom,
            name,
            noPadding,
          },
          attrs: { ...attrs },
          class: { [`${props.className}`]: !!props.className },
        },
        {
          default: () => slots.default && slots.default(),
        },
      )
    }
  },
})

const Item = connect(
  FormBaseItem,
  mapProps(
    { validateStatus: true, title: 'label', required: true },
    (props, field) => {
      if (isVoidField(field)) return props
      if (!field) return props
      const takeMessage = () => {
        if (field.validating) return
        if (props.feedbackText) return props.feedbackText
        if (field.selfErrors.length) return field.selfErrors
        if (field.selfWarnings.length) return field.selfWarnings
        if (field.selfSuccesses.length) return field.selfSuccesses
      }
      const errorMessages = takeMessage()
      return {
        feedbackText: Array.isArray(errorMessages) ? errorMessages.join(', ') : errorMessages,
        extra: field.pattern !== 'readPretty' ? props.extra || field.description : '',
        arrow: field.pattern !== 'readPretty' && props.arrow,
        icon: field.pattern !== 'readPretty' && props.icon,
        name: field.props.name,
      }
    },
    (props, field) => {
      if (isVoidField(field)) return props
      if (!field) return props
      let feedbackStatus = false
      if (field.pattern !== 'readPretty') {
        feedbackStatus =
          field.validateStatus === 'validating'
            ? 'pending'
            : (Array.isArray(field.decorator) &&
                field.decorator[1] &&
                field.decorator[1].feedbackStatus) ||
              field.validateStatus
      }

      return {
        feedbackStatus,
      }
    },
    (props, field) => {
      if (isVoidField(field)) return props

      if (!field) return props
      let asterisk = false
      if (field.required && field.pattern !== 'readPretty') {
        asterisk = true
      }
      if ('asterisk' in props) {
        asterisk = props.asterisk
      }
      return {
        asterisk,
      }
    },
  ),
)

export const FormItem = Object.assign(Item, {
  BaseItem: FormBaseItem,
})

export const FormItemView = InnerItem

export default FormItem
